import { useState } from 'react';
import { isDesktop } from '../../MediaQuery/desktop';
import desktop_floating_qr from './Assets/desktop_floating_qr_2.png';
import mobile_sticky_bar from './Assets/mobile_sticky_bar.png';
import './style.less';

const CloseButton = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-x size-4"
    aria-hidden="true"
  >
    <path d="M18 6 6 18"></path>
    <path d="m6 6 12 12"></path>
  </svg>
);

export const StickyBar = () => {
  const [isOpen, setIsOpen] = useState(true);

  return isDesktop() ? (
    <div className="StickyBar__Desktop">
      {isOpen && (
        <div className="StickyBar__Desktop__Content">
          <button aria-label="close" onClick={() => setIsOpen(false)}>
            {CloseButton}
          </button>
          <a href={'https://shopeepay.vn/khuyen-mai-dang-dien-ra/taiapp'}>
            <img src={desktop_floating_qr} alt="QR" />
          </a>
        </div>
      )}
    </div>
  ) : (
    <div className="StickyBar__Mobile">
      <a href="https://shopeepayvn.onelink.me/Wnz3/sticky">
        <img src={mobile_sticky_bar} alt="QR" />
      </a>
    </div>
  );
};
